import qs from "qs";
import offerCustomPaths from "./offerCustomPaths";
import { CLICK_FUNNEL_OFFER_TYPE } from "./launchOffer";
import env from '../../../../environments';

type urlParams = {
  launchOfferType?: string;
  offerCode: string;
  isProductCatalogOffer?: boolean;
  params?: { [key: string]: string };
};


const getUtmTrackingUrl = ({
  offerCode,
  launchOfferType,
  isProductCatalogOffer,
  params,
}: urlParams): string | null => {
  
  const query = qs.stringify(params);
  
  if (isProductCatalogOffer) {
    const productCatalogOfferUrl = env.PUBLISHED_OFFER_URL + offerCode;
    return `${productCatalogOfferUrl}?${query}`;
  }

  // The Chargify-era checkout /onboard/place-order/:offerCode is retired
  // (hubspot-off-block-3 task 98), so only ClickFunnels offers get a link here.
  if (launchOfferType !== CLICK_FUNNEL_OFFER_TYPE) return null;

  const locationOrigin = import.meta.env.VITE_LAUNCH_OFFER_URL;

  return `${locationOrigin}/landing-pages/${offerCustomPaths[offerCode]}?${query}`;
};

export default getUtmTrackingUrl;